import { render, staticRenderFns } from "./patient.html?vue&type=template&id=461e0ad2&"
import script from "./patient.js?vue&type=script&lang=js&"
export * from "./patient.js?vue&type=script&lang=js&"
import style0 from "./patient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports